export default function() {
    this.$store.commit('stopLoading');
    this.loadPost()
}
